import * as React from 'react';
import { UserMenu } from 'moduleBase/types/Menu';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { When } from 'react-if';
import app from 'srcJs/App';
import { FC } from 'react';

type ActionsProps = Pick<UserMenu, 'action' | 'frozen' | 'wait'> & {
  hide: () => void,
};
const Actions: FC<ActionsProps> = ({
  hide,
  action,
  frozen,
  wait,
}) => (
  <>
    <When condition={wait}>
      <div className="dropdown-flat-list__balance">
        <span className="color-858585">
          {app.tForReact('base', 'Wait:')}
          {' '}
          {wait}
        </span>
      </div>
    </When>
    <When condition={frozen}>
      <div className="dropdown-flat-list__balance">
        <span className="color-858585">
          {app.tForReact('base', 'Frozen:')}
          {' '}
          {frozen}
        </span>
      </div>
    </When>
    {action ? (
      <div className="dropdown-flat-list__balance">
        <MenuItem
          visible={Boolean((action))}
          label={action.label}
          route={action.route}
          url={action.url}
          className="btn btn-primary btn-block"
          onClick={() => {
            hide();
          }}
        />
      </div>
    ) : null}
  </>
);
export default Actions;
